import axios from "axios";
import Config from "../../Config";
import {
   toast
} from "react-toastify";

const token = localStorage.getItem("auth_token")
const config = {
   headers: {
      Authorization: `Bearer ${token}`
   }
};

export const fetchCampaigns = async (setData, setLoading, setError) => {
   setLoading(true);
   setError(false);

   try {

      const [CampaignResponse, CampaignStatsResponse] = await Promise.all([
         axios.get(`https://backend.dealboxx.promo/api/admin/campaign`, config),
         axios.get('https://backend.dealboxx.promo/api/admin/stats/campaign', config),
      ]);


      //  

      if (CampaignResponse.data.data.status_code === "000" && CampaignStatsResponse.data.data.status_code === "000") {
         setData({
            campaignStats: CampaignStatsResponse.data.data.data,
            campaignData: CampaignResponse.data.data.data,
         });
         // console.log(CampaignStatsResponse.data.data.data);
         setLoading(false);

      } else {
         setError(true);
         throw new Error([CampaignResponse.data.data.data.reason, CampaignStatsResponse.data.data.data.reason] || "Error Loading Campaign Ids");

      }

   } catch (error) {
      // toast.error("Failed to Load Campaign Ids");
      setLoading(false);
      setError(true);

   }

}




export const activateCampaign = async (values, CampaignSlug, {
   onSuccess,
   onError
}) => {

   try {
      console.log(CampaignSlug);
      const response = await axios.post(`https://backend.dealboxx.promo/api/admin/updateStatus/campaign/${CampaignSlug}`, values, config);

      console.log(response.data);
      if (response.data.data.status_code === "000") {
         onSuccess();

         toast.success('Campaign Approved successfully!');
      } else {
         throw new Error(response.data.data.reason || 'Failed to approve Campaign ');
      }

   } catch (error) {
      console.log(error);
      // onError(true);
      toast.error('Failed to Approve Campaign!');

   }

}
export const deactivateCampaign = async (values, CampaignSlug, {
   onSuccess,
   onError
}) => {

   try {
      console.log(values.Campaign);
      const response = await axios.post(`https://backend.dealboxx.promo/api/admin/updateStatus/campaign/${CampaignSlug}`, values, config);

      console.log(response.data);
      if (response.data.data.status_code === "000") {
         onSuccess();

         toast.success('Campaign Rejected successfully!');
      } else {
         throw new Error(response.data.data.reason || 'Failed to reject Campaign');
      }

   } catch (error) {
      console.log(error);
      // onError(true);
      toast.error('Failed to reject Campaign!');

   }

}
